var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function createKeyedMutex() {
    const invocations = new Map();
    return {
        runLocked(key, fn) {
            return __awaiter(this, void 0, void 0, function* () {
                const ongoingInvocation = invocations.get(key);
                const nextProcess = runFinally(() => __awaiter(this, void 0, void 0, function* () {
                    try {
                        yield fn();
                    }
                    finally {
                        if (invocations.get(key) === nextProcess) {
                            invocations.delete(key);
                        }
                    }
                }), ongoingInvocation);
                invocations.set(key, nextProcess);
                yield nextProcess;
            });
        },
    };
}
/**
 * run and return value of `fn()` once `promise` has been completed (resolved or rejected) if any.
 */
function runFinally(fn, promise) {
    var _a;
    return (_a = promise === null || promise === void 0 ? void 0 : promise.then(fn, fn)) !== null && _a !== void 0 ? _a : fn();
}
//# sourceMappingURL=keyed_mutex.js.map